import React, { useCallback } from 'react'
import Scrollbars from 'components/Scrollbars'
import classes from './Sidebar.module.scss'
import {
  NavbarTab
} from 'components/Navbar'
import KanBoIcon from 'components/KanBoIcon'
import { useDispatch, useSelector } from 'react-redux'
import { sagaActions } from 'store/sagas'
import { ScreenSizeTypes, useScreenSize } from 'components/ScreenSize'
import useOnClickOutside from 'use-onclickoutside'
import {
  setIsSidebarVisible
} from 'store/redux/layout'
import MenuDivider from './components/MenuDivider'
import styled from 'styled-components'

const TopMenuDivider = styled(MenuDivider)`
  margin-top: 0;
  margin-bottom: 0;
`

type Props = {
  closeOnClickOutside?: boolean
}

const Sidebar: React.FC<Props> = ({
  children,

  closeOnClickOutside = true,
}) => {
  const dispatch = useDispatch()

  const miniMenu = useSelector<any, boolean>(state => state.kanbo.currentUser.settings.miniMenu)
  const isSidebarVisible = useSelector<any, boolean>(state => state.kanbo.layout.isSidebarVisible)

  const screenSize = useScreenSize()

  const isScreenMedium = screenSize.width > ScreenSizeTypes.MEDIUM

  const ref = React.useRef(null)

  const handleClickOutside = useCallback(() => {
    if (miniMenu && isSidebarVisible && closeOnClickOutside) {
      dispatch(setIsSidebarVisible(false))
    }
  }, [miniMenu, isSidebarVisible, closeOnClickOutside])

  useOnClickOutside(ref, handleClickOutside)

  const handleToggleMobileSidebarClick = (event) => {
    event.preventDefault()

    dispatch(setIsSidebarVisible(!isSidebarVisible))
  }

  return (
    <div
      ref={ref}
      className={classes.sidebar}
    >
      {((miniMenu || !isScreenMedium)) &&
        <NavbarTab
          className={classes.menuTile}
          onClick={handleToggleMobileSidebarClick}
        >
          <KanBoIcon name='kanbo-16-hamburger-menu' />
        </NavbarTab>
      }
      <div className={classes.menuWrapper}>
        {isScreenMedium &&
          <NavbarTab
            className={classes.pin}
            onClick={() => {
              dispatch(sagaActions.requestChangeUserSettings({
                miniMenu: !miniMenu
              }))
            }}
          >
            <KanBoIcon name='kanbo-16-pin-it' className={miniMenu ? undefined : 'text-primary'} />
          </NavbarTab>
        }
        <TopMenuDivider />
        <Scrollbars
          className={classes.sidebarWrapper}
        >
          <div className={classes.menu}>
            {children}
          </div>
        </Scrollbars>
      </div>
    </div>
  )
}

export default Sidebar
